import styled, { css } from 'styled-components';

const disabledStyle = css`
  outline: none;
  cursor: auto;
  opacity: 0.4;
`;

const enabledStyles = css`
  &:hover {
    background-color: ${props =>
      props.appearance === 'primary' ? `${props.theme.colors.red}33` : 'rgba(255, 255, 255, 0.1)'};
  }
  &:focus {
    background-color: rgba(255, 255, 255, 0.1);
    outline: none;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  font-size: ${props => props.theme.typography.fontSize.m};
  color: ${props => props.theme.colors.lighter};
  text-align: center;
  text-transform: uppercase;
  background-color: rgba(0, 0, 0, 0.1);
  border: ${props => props.theme.dimensions.border.width} solid
    ${props =>
      props.appearance === 'primary' ? props.theme.colors.red : props.theme.colors.border};
  border-radius: 20px;
  padding: 10px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  ${props => (props.disabled ? disabledStyle : enabledStyles)}
`;

const ButtonJarvis = styled.button`
  cursor: pointer;
  font-size: 1em;
  background: transparent;
  text-transform: uppercase;
  color: rgba(204, 0, 0, 1);
  position: relative;
  border-width: 3px;
  border-style: solid;
  border-color: rgba(204, 0, 0, 0.7); /* fallback color */
  border-image-slice: 1;
  border-radius: 1000px;
  width: 7em;
  height: 3.3em;
  text-align: center;
  box-shadow: 0 0 1em 0 rgba(255, 192, 192, 0.5);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  &:hover {
    color: rgba(255, 255, 255, 0.6);
  }
  &:hover:after {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    opacity: 0.4;
    box-shadow: 0 0 5px 1px rgba(255, 255, 255, 0.5), inset 0 0 1px 1px rgba(255, 255, 255, 0.5);
    border-radius: 100000px;
  }
`;

export default {
  Button,
  ButtonJarvis,
};
